import { UserResponse } from "@shared/interfaces/user.model";

export interface DashboardPermissionFlags {
  canViewApprovalTab: boolean;
  canViewMTApprovalTab: boolean;
  canViewApprovalRadioButton: boolean;
}

type UserPermissionSource = Partial<UserResponse> & {
  canViewApprovalTab?: unknown;
  canViewMTApprovalTab?: unknown;
  canViewApprovalRadioButton?: unknown;
};

const MOTOR_APPROVAL_MENU_ACCESS = "SAT_MT_REFER_APPR";
const EXCLUDED_PENDING_APPROVAL_CODES = new Set([
  MOTOR_APPROVAL_MENU_ACCESS,
  "CNMT_REFER_APPR",
]);

function asOptionalBoolean(value: unknown): boolean | undefined {
  return typeof value === "boolean" ? value : undefined;
}

function normalizeMenuAccess(menuAccess: unknown): string[] {
  return Array.isArray(menuAccess)
    ? menuAccess.filter(
        (item): item is string =>
          typeof item === "string" && item.trim() !== "",
      )
    : [];
}

function hasPendingApprovalAccess(menuAccess: string[]): boolean {
  return menuAccess.some(
    (code) =>
      code.endsWith("_REFER_APPR") &&
      !EXCLUDED_PENDING_APPROVAL_CODES.has(code),
  );
}

function hasMotorApprovalAccess(menuAccess: string[]): boolean {
  return menuAccess.includes(MOTOR_APPROVAL_MENU_ACCESS);
}

export function resolveDashboardPermissionFlags(
  user: UserPermissionSource | null | undefined,
): DashboardPermissionFlags {
  const menuAccess = normalizeMenuAccess(user?.menuAccess);

  const canViewApprovalTab =
    asOptionalBoolean(user?.canViewApprovalTab) ??
    hasPendingApprovalAccess(menuAccess);
  const canViewMTApprovalTab =
    asOptionalBoolean(user?.canViewMTApprovalTab) ??
    hasMotorApprovalAccess(menuAccess);
  const canViewApprovalRadioButton =
    asOptionalBoolean(user?.canViewApprovalRadioButton) ??
    (canViewApprovalTab || canViewMTApprovalTab);

  return {
    canViewApprovalTab,
    canViewMTApprovalTab,
    canViewApprovalRadioButton,
  };
}
